import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { CheckCircle2, MoonStar } from 'lucide-react';
import { motion } from 'framer-motion';
const BOOK_COVER = 'https://cdn.magicpatterns.com/uploads/7vk2sAJCKwsWpiQTDGFMxB/ChatGPT_Image_Mar_29,_2026,_07_19_38_PM.webp';
export function Hero() {
  return <section className="relative w-full bg-night-950 text-white overflow-hidden pt-12 pb-16 md:pt-20 md:pb-24 lg:pt-28 lg:pb-36 px-6" data-id="element-156">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-157">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-purple-900/20 blur-[60px]" data-id="element-158" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-indigo-900/20 blur-[60px]" data-id="element-159" />
      </div>

      <div className="relative max-w-6xl mx-auto z-10" data-id="element-160">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-161">
          {/* Text column */}
          <div className="text-center lg:text-left order-1" data-id="element-162">
            <FadeIn data-id="element-163">
              <div className="inline-flex items-center justify-center p-2 md:p-3 mb-6 md:mb-8 rounded-full bg-white/5 border border-white/10" data-id="element-164">
                <MoonStar className="w-4 h-4 md:w-5 md:h-5 text-purple-400 mr-2" data-id="element-165" />
                <span className="text-xs md:text-sm font-medium tracking-wide text-purple-200 uppercase" data-id="element-166">
                  Mente en Calma
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.05} data-id="element-167">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-medium leading-tight mb-4 md:mb-6 text-white" data-id="element-168">
                ¿Tu mente se prende justo cuando te acuestas?
              </h1>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-169">
              <p className="text-lg md:text-2xl text-purple-100/80 font-light mb-4 md:mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed" data-id="element-170">
                Aprende a apagarla en 7 noches — sin pastillas, sin meditaciones
                complicadas y sin una hora libre que no tienes.
              </p>
            </FadeIn>

            <FadeIn delay={0.12} data-id="element-171">
              <a href="https://www.viventispace.com/cart/46127430566076:1" target="_blank" rel="noopener noreferrer" className="inline-block text-purple-300 font-medium mb-2 md:mb-3 text-lg md:text-xl hover:text-purple-200 transition-colors cursor-pointer" data-id="element-172">
                Por solo $17{' '}
              </a>
              <motion.div className="text-xs md:text-sm text-purple-300/80 font-medium mb-6 md:mb-8 flex items-center justify-center lg:justify-start gap-1.5" animate={{
              opacity: [0.7, 1, 0.7]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-173">
                <span data-id="element-174">🔥</span> Edición limitada — Solo 23 copias disponibles
              </motion.div>
            </FadeIn>

            <FadeIn delay={0.15} className="hidden md:block" data-id="element-175">
              <p className="text-lg text-slate-300 mb-10 max-w-lg mx-auto lg:mx-0" data-id="element-176">
                Mente en Calma es el método paso a paso para mujeres que llegan
                a la noche agotadas… pero con la cabeza que no para.
              </p>
            </FadeIn>

            <FadeIn delay={0.18} data-id="element-177">
              <div className="flex flex-col items-center lg:items-start mb-10 lg:mb-0" data-id="element-178">
                <Button href="https://www.viventispace.com/cart/46127430566076:1" className="w-full sm:w-auto text-base md:text-xl px-8 md:px-10 py-4 md:py-5" data-id="element-179">
                  🟣 Quiero dormir profundo esta semana →
                </Button>

                <div className="mt-5 md:mt-6 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 sm:gap-6 text-xs md:text-sm text-slate-400" data-id="element-180">
                  <div className="flex items-center" data-id="element-181">
                    <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-purple-400 mr-2" data-id="element-182" />
                    <span data-id="element-183">Acceso inmediato</span>
                  </div>
                  <div className="flex items-center" data-id="element-184">
                    <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-purple-400 mr-2" data-id="element-185" />
                    <span data-id="element-186">Formato PDF descargable</span>
                  </div>
                  <div className="flex items-center" data-id="element-187">
                    <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-purple-400 mr-2" data-id="element-188" />
                    <span data-id="element-189">Garantía 7 días</span>
                  </div>
                </div>
              </div>
            </FadeIn>

            {/* Book cover - mobile only (moved below CTA) */}
            <FadeIn delay={0.2} className="lg:hidden mt-8" data-id="element-190">
              <div className="flex justify-center" data-id="element-191">
                <motion.img src={BOOK_COVER} alt="Mente en Calma — Portada del libro" loading="eager" fetchPriority="high" className="w-56 sm:w-64 rounded-2xl" style={{
                WebkitMaskImage: 'radial-gradient(ellipse 85% 85% at center, black 70%, transparent 100%)',
                maskImage: 'radial-gradient(ellipse 85% 85% at center, black 70%, transparent 100%)'
              }} initial={{
                rotate: -2
              }} whileInView={{
                rotate: 0
              }} transition={{
                duration: 0.8,
                ease: 'easeOut'
              }} data-id="element-192" />
              </div>
            </FadeIn>
          </div>

          {/* Book cover - desktop only */}
          <FadeIn delay={0.15} className="hidden lg:flex justify-center order-2" data-id="element-193">
            <motion.div className="relative" initial={{
            rotate: -3,
            y: 10
          }} whileInView={{
            rotate: 0,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            ease: 'easeOut'
          }} data-id="element-194">
              <div className="absolute -inset-8 bg-purple-500/10 rounded-full blur-[60px] pointer-events-none" data-id="element-195" />
              <img src={BOOK_COVER} alt="Mente en Calma — Portada del libro" loading="eager" fetchPriority="high" className="relative w-80 xl:w-96 rounded-2xl" style={{
              WebkitMaskImage: 'radial-gradient(ellipse 85% 85% at center, black 75%, transparent 100%)',
              maskImage: 'radial-gradient(ellipse 85% 85% at center, black 75%, transparent 100%)'
            }} data-id="element-196" />
            </motion.div>
          </FadeIn>
        </div>
      </div>
    </section>;
}